var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.131 3.864l1.037-1.037c.49-.49.504-1.08.036-1.563l-.46-.468C8.268.313 7.656.356 7.166.839l-1.03 1.03 1.995 1.995zM1.077 9.52l1.948-.735 4.248-4.24-1.83-1.818-4.24 4.24L.485 8.91c-.145.387.257.734.592.61z",
    fillRule: "nonzero"
  })));
}
export default SvgProfileIconEdit;